module.exports = '<svg width="32" height="32" viewBox="0 0 32 32"><path d="M16 0C7.164 0 0 7.164 0 16s7.164 16 16 16 16-7.164 16-16S24.836 0 16 0zm5.318 17.002l-7.752 4.71c-.864.654-1.566.158-1.566-1.114v-9.196c0-1.27.702-1.77 1.566-1.116L21.318 15c.91.552.91 1.45 0 2.002z"/></svg>'


//////////////////
// WEBPACK FOOTER
// ./~/li-icons/dist/js/play-4.js
// module id = 1347
// module chunks = 14